import { render, staticRenderFns } from "./CapitalInvestor.vue?vue&type=template&id=ea32fbea&scoped=true&"
import script from "./CapitalInvestor.vue?vue&type=script&lang=js&"
export * from "./CapitalInvestor.vue?vue&type=script&lang=js&"
import style0 from "./CapitalInvestor.vue?vue&type=style&index=0&id=ea32fbea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea32fbea",
  null
  
)

export default component.exports